import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const ACTION_COLOR = {
  create: "#dfff00",
  read: "#a1a1aa",
  delete: "#ff0026",
  login: "#16ec06",
  grant_consent: "#e3735e",
  seed: "#71717a",
};

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    api.get("/audit-log", { params: { limit: 200 } }).then((r) => setLogs(r.data));
  }, []);

  return (
    <div className="space-y-5" data-testid="club-audit">
      <div>
        <div className="font-label">GDPR</div>
        <h1 className="font-heading uppercase text-3xl sm:text-4xl tracking-tight">Audit log</h1>
        <p className="text-zinc-400 text-sm mt-1">
          Every read & write of observations, goals, and consents is recorded.
        </p>
      </div>
      {!logs && <div className="skeleton h-40" />}
      <div className="surface overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#1a1a1a] text-zinc-500">
            <tr>
              <th className="text-left px-3 py-2 font-label">When</th>
              <th className="text-left px-3 py-2 font-label">User</th>
              <th className="text-left px-3 py-2 font-label">Action</th>
              <th className="text-left px-3 py-2 font-label">Entity</th>
            </tr>
          </thead>
          <tbody>
            {logs?.map((l) => (
              <tr key={l.id} className="border-t border-[#27272a]" data-testid={`audit-${l.id}`}>
                <td className="px-3 py-2 text-zinc-400 whitespace-nowrap">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="px-3 py-2">
                  {l.user_name} <span className="text-xs text-zinc-500">({l.user_role})</span>
                </td>
                <td className="px-3 py-2">
                  <span className="font-semibold" style={{ color: ACTION_COLOR[l.action] || "#a1a1aa" }}>
                    {l.action}
                  </span>
                </td>
                <td className="px-3 py-2 text-zinc-300">
                  {l.entity_type} <span className="text-xs text-zinc-500 font-mono">{l.entity_id.slice(0, 8)}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
